import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import FishLogo from '@components/icons/FishLogo'
import { useCustomProductTiles } from '@features/products/api/get-custom-product-grid-tiles'

import { getCurrencyFromCountry } from '@lib/utils'
import { selectAlpha2Code, selectChannel } from '@redux/globalSlice'
import { openModalView } from '@redux/modalSlice'
import { useAppDispatch } from '@redux/store'
import { selectWishlist } from '@redux/wishlistSlice'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import Module from '..'
import CustomProductGrid from '../CustomProductGrid/CustomProductGrid'
import styles from './WishList.module.scss'
export type WishListProps = {
  headlineRichText: string
  textAboveInput: string
  submitSuccessFullMsg: string
  placeholder: string
  termsText: string
  termsReadMoreText: string
  submitBtnText: string
  newsletterCheckboxLabel: string
  emptyWishlistContent: any
}
const WishList: FC<WishListProps> = ({ ...props }) => {
  const alpha2Code = useSelector(selectAlpha2Code)
  const channel = useSelector(selectChannel)
  const wishlist = useSelector(selectWishlist)
  const dispatch = useAppDispatch()

  const query = wishlist.map((item) => `variant_id:${item}`).join(' OR ')

  const { data, isLoading } = useCustomProductTiles({
    variables: {
      channel: channel,
      currency: getCurrencyFromCountry(alpha2Code),
      query,
      urlParams: {},
    },
    queryConfig: {
      enabled: !!query,
    },
  })

  // create loading state to prevent wishlist from showing empty before it has been fetched
  if (!wishlist) {
    return null
  }
  const wishlistProducts =
    wishlist.map((wishlistItem) => {
      const product = data?.find((product) =>
        product.variants.edges.some(
          (variantEdge) => variantEdge.node.id === wishlistItem,
        ),
      )

      if (!product) return null

      // Find the variant in the product that matches the wishlist item
      const heroVariant = product.variants.edges.find(
        (variantEdge) => variantEdge.node.id === wishlistItem,
      )?.node

      return {
        ...product,
        heroVariant: heroVariant || null,
      }
    }) ?? []
  // Prevent the UI from rendering empty before data is loaded
  if (!wishlist || (wishlist.length > 0 && isLoading)) {
    return null
  }
  return wishlist?.length > 0 ? (
    <div className={styles.root}>
      <TrustedHtml html={props.headlineRichText} />
      <CustomProductGrid
        products={wishlistProducts}
        wishlistMode={true}
        colorSelector={false}
        colorSorting={null}
        collectionFilter={false}
        debugMode={false}
        headline={null}
      />

      <button
        className={styles.shareWishlistBtn}
        onClick={() =>
          dispatch(
            openModalView({
              modalView: 'SHARE_WISHLIST',
              props: {
                ...props,
              },
            }),
          )
        }
      >
        Share your wishlist
      </button>
    </div>
  ) : props.emptyWishlistContent && props.emptyWishlistContent.length > 0 ? (
    props.emptyWishlistContent.map((component, index) => {
      return (
        <Module
          {...component}
          __typename={
            component.contentTypeAlias.charAt(0).toUpperCase() +
            component.contentTypeAlias.slice(1)
          }
          key={index}
          lcp={
            props.emptyWishlistContent
              .filter((x) => x.__typename !== 'Spacer')
              .findIndex((x) => x === component) < 2
          }
        />
      )
    })
  ) : (
    <div className={styles.emptyContainer}>
      <FishLogo />
      <p className="pt-4">Your wish list is empty</p>
    </div>
  )
}

export default WishList
